import { SWReactIcons } from "@similarweb/icons";

export const NoSuggestionsArt = () => <SWReactIcons iconName={"no-data-tree"} />;
